import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { show as getPart } from "MODULES/parts/actions";
import { Map } from "immutable";
import {
  Pagination,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search } from "MODULES/shared/components";
import { loadRecord } from "MODULES/shared/decorators";
import BackToPart from "MODULES/parts/components/shared/BackToPart";
import Table from "./Table";
import { partInventories } from "../../pagination";

export function Inventories({ part }) {
  return (
    <Search search={partInventories} syncWithUrl>
      {searchProps => (
        <div>
          <BackToPart part={part} />
          <TitleWithFilters {...searchProps} title="Full Inventory List" />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

Inventories.propTypes = {
  part: PropTypes.instanceOf(Map).isRequired
};

export default connect(state => ({
  part: state.partDetail.get("part")
}))(
  loadRecord({
    reducer: "partDetail",
    name: "part",
    action: getPart
  })(Inventories)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Inventories/Inventories.jsx